import type { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { number, type NumberColumnParams } from './number';
import type { ColDefFactory, Column } from './types';

export interface SecurityNumberColumnParams extends NumberColumnParams {
  /**
   * Symbol for the Security to lookup in the securitiesBySymbol map
   */
  symbolField: string;
  /**
   * Property for the value on the Security
   */
  securityField: string;
}

/**
 * Number column to render values from the Security object
 * - to avoid field confusion, the column property 'Field' is not involved here, but the params must be set to the correct symbolField and securityField
 * - use the column ID to ensure uniqueness on your field when it comes to the column definitions
 *
 * See {@link AgGridSecurityProps} for parameter options.
 */
export const securityNumber: ColDefFactory<Column<SecurityNumberColumnParams>> = column => ({
  ...number(column),
  valueGetter: (params: ValueGetterParams<unknown>) => {
    if (!params.node?.data || !column.params) {
      return undefined;
    }
    const symbol = get(params.node.data, column.params.symbolField);
    const security = symbol ? params.context.current.securitiesBySymbol?.get(symbol) : undefined;
    return get(security, column.params.securityField);
  },
});
